import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';

import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import ErrorIcon from '@/images/CloseWithRedCircle.svg';
import { RequestStatus } from '@/pages/avatar/common';
import { useCreateAvatarStore } from '@/pages/avatar/common/context';
import { AvatarFootage } from '@/pages/avatar/components/AvatarFootage';
import theme from '@/theme';

import { FootageInstructions } from '../AvatarFootage/FootageInstructions';
import { ErrorTitle, StepTitle } from '../Styled/Title';

const FootageStepContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 32px 0 40px;
    gap: 40px;
    max-height: calc(100% - 96px);
    max-width: 900px;
    margin: 0 auto;
`;

const Title = observer(() => {
    const createAvatarStore = useCreateAvatarStore();
    if (createAvatarStore.footageUploadStatus === RequestStatus.ERROR) {
        return (
            <ErrorTitle>
                <MaskedIcon src={ErrorIcon} size="32px" color={theme.colors.error.main} />
                Footage error
            </ErrorTitle>
        );
    }

    const title = createAvatarStore.isFootageProvided ? 'Review your footage' : 'Upload footage to create your Avatar';
    return <StepTitle>{title}</StepTitle>;
});

interface Props {
    shouldExtendInstruction?: boolean;
}

export const FootageStep = ({ shouldExtendInstruction }: Props) => {
    return (
        <FootageStepContainer>
            <Title />
            {!!shouldExtendInstruction && <FootageInstructions />}
            <AvatarFootage />
        </FootageStepContainer>
    );
};
